<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L1lvdA/tc-custom/9780226069159.jpg?1737195128199" alt="This image is the cover for the book How Partisan Media Polarize America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How Partisan Media Polarize America
      </h1>
      <p class="bookDescription body article font2">
        <p>Forty years ago, viewers who wanted to watch the news could only choose from among the major broadcast networks, all of which presented the same news without any particular point of view. Today we have a much broader array of choices, including cable channels offering a partisan take. With partisan programs gaining in popularity, some argue that they are polarizing American politics, while others counter that only a tiny portion of the population watches such programs and that their viewers tend to already hold similar beliefs.           <br/> In <i>How Partisan Media Polarize America</i>, Matthew Levendusky confirms—but also qualifies—both of these claims. Drawing on experiments and survey data, he shows that Americans who watch partisan programming do become more certain of their beliefs and less willing to weigh the merits of opposing views or to compromise. And while only a small segment of the American population watches partisan media programs, those who do tend to be more politically engaged, and their effects on national politics are therefore far-reaching.           <br/> In a time when politics seem doomed to partisan discord, <i>How Partisan Media Polarize America</i> offers a much-needed clarification of the role partisan media might play.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew Levendusky
      </h2>
      
      <p class="authorDescription body article"><B>Matthew Levendusky</B> is assistant professor of political science at the University of Pennsylvania and the author of <I>The Partisan Sort: How Liberals Became Democrats and Conservatives Became Republicans</I>, also published by the University of Chicago Press. He lives in Philadelphia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b315906a